import NotificationActions from '../../actions/NotificationActions';
import GuestListActions from '../../actions/GuestListActions';
import PopupActions from '../../actions/PopupActions';

import UserStore from '../../stores/UserStore';

import { endPoints as EndPoints } from '../../constants/GuestListConstants';
import AjaxPromises from '../../utils/AjaxPromises';

class ChangeRoom extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false,
            rooms   : UserStore.getState().rooms
        }

        this.assignGuestToRoom = this.assignGuestToRoom.bind(this);
        this.onUserStoreChange = this.onUserStoreChange.bind(this);
    }

    componentDidMount() {
        UserStore.addChangeListener(this.onUserStoreChange);
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this.onUserStoreChange);
    }

    onUserStoreChange() {
        this.setState({ rooms : UserStore.getState().rooms });
    }

    assignGuestToRoom(room, updateGuestList) {
        var self            = this;

        var formData        = UserStore.getApiData();
        formData.Guest_id   = this.props.guest.Guest_id;
        formData.ShipmentId = this.props.guest.ShipmentId;
        formData.RoomId     = room.RoomId;
        formData.ScheduleId = this.props.guest.ScheduleId;

        AjaxPromises.POST(EndPoints.GUEST_TO_ROOM,
            formData).then(res => {
                NotificationActions.addNotification({
                    type : res.Result ? 'success' : 'error',
                    body : res.Result ? 'Room Updated to '+room.RoomName : 'Room Update Failed'
                });

                if (res.Result){
                    if(UserStore.getState().selectedLocation.UseSmartCheckin){
                        const guestUpdated = {
                            Guest_id: this.props.guest.Guest_id,
                            Room: room.RoomName
                        };
                        GuestListActions.addOrUpdateGuest(guestUpdated);
                    }else{
                        GuestListActions.loadGuestList(false);
                    }
                    PopupActions.close();
                }
            }
        );
    }

    render() {
        var self  = this;
        var rooms = this.state.rooms;
        var guest = this.props.guest;

        return (
            <div className='popup__content change-status'>

                <div className='popup-header'>
                    CHANGE ROOM

                    <div
                        className='popup-close'
                        onClick={() => { PopupActions.close(); }}>

                        <i className='fa fa-times' aria-hidden='true' />
                    </div>
                </div>

                { rooms.map(room => {
                    return (
                        <button
                            onClick={() => { this.assignGuestToRoom(room); }}
                            className={'btn-green '+(room.RoomId !== guest.CurrentRoom ? 'btn-green__disabled' : '')}
                            key={room.RoomId}>

                            {room.RoomName}
                        </button>
                    );
                })}
            </div>
        );
    }
}

export default ChangeRoom;



// WEBPACK FOOTER //
// ./ui_src/app/components/popup/ChangeRoom.react.jsx